import { Component, HostListener, ChangeDetectionStrategy } from '@angular/core';
import { PilotageComponent } from '../pilotage/pilotage.component';

@Component({
  selector: 'app-pilotage-fullscreen',
  standalone: true,
  imports: [PilotageComponent],
  template: `
    <div class="fullscreen-wrapper" [style.font-size.px]="baseFontSize">
      <app-pilotage></app-pilotage>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [`
    :host {
      display: block;
      width: 100vw;
      height: 100vh;
      overflow: hidden;
    }

    .fullscreen-wrapper {
      width: 100%;
      height: 100%;
      background: #DDD6FE;
      padding: 1em;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
    }

    .fullscreen-wrapper ::ng-deep .monitor {
      flex: 1;
      display: flex;
      flex-direction: column;
      height: 100%;
      gap: 0.6em;
    }

    .fullscreen-wrapper ::ng-deep .sites-grid {
      flex: 1;
      gap: 0.5em;
      align-content: start;
      grid-auto-rows: auto;
    }

    .fullscreen-wrapper ::ng-deep .site-card {
      padding: 0.7em 0.9em;
      gap: 0.4em;
      border-radius: 0.7em;
      min-height: 0;
    }

    .fullscreen-wrapper ::ng-deep .site-body { gap: 0.2em; }
    .fullscreen-wrapper ::ng-deep .site-name { font-size: 1em; }
    .fullscreen-wrapper ::ng-deep .site-badge { font-size: 0.55em; padding: 0.2em 0.5em; }
    .fullscreen-wrapper ::ng-deep .site-label { font-size: 0.8em; }
    .fullscreen-wrapper ::ng-deep .site-info { font-size: 0.75em; }
    .fullscreen-wrapper ::ng-deep .site-attente { font-size: 0.8em; margin-top: 0.1em; }
    .fullscreen-wrapper ::ng-deep .site-since { font-size: 0.7em; }
    .fullscreen-wrapper ::ng-deep .site-alerts { padding-top: 0.3em; gap: 0.15em; }
    .fullscreen-wrapper ::ng-deep .site-alert { font-size: 0.7em; }
    .fullscreen-wrapper ::ng-deep .site-alert-btn { font-size: 0.65em; padding: 0.25em 0.6em; }
    .fullscreen-wrapper ::ng-deep .site-alert-actions { gap: 0.3em; margin-top: 0.2em; }
    .fullscreen-wrapper ::ng-deep .site-timeline { gap: 0.3em; padding-top: 0.3em; }
    .fullscreen-wrapper ::ng-deep .tl-time { font-size: 0.45em; }
    .fullscreen-wrapper ::ng-deep .tl-dot { width: 0.45em; height: 0.45em; }
    .fullscreen-wrapper ::ng-deep .site-summary { font-size: 0.65em; }
    .fullscreen-wrapper ::ng-deep .site-status-dot { width: 0.55em; height: 0.55em; }
    .fullscreen-wrapper ::ng-deep .site-card-header { gap: 0.5em; }

    .fullscreen-wrapper ::ng-deep .bottom-grid {
      flex-shrink: 0;
      gap: 0.5em;
      padding-top: 0.5em;
    }

    .fullscreen-wrapper ::ng-deep .bottom-card { padding: 0.6em 0.9em; border-radius: 0.7em; }
    .fullscreen-wrapper ::ng-deep .bottom-title { font-size: 0.85em; margin-bottom: 0.5em; }
    .fullscreen-wrapper ::ng-deep .events-list { gap: 0.35em; }
    .fullscreen-wrapper ::ng-deep .event-row { gap: 0.4em; }
    .fullscreen-wrapper ::ng-deep .event-time { font-size: 0.7em; }
    .fullscreen-wrapper ::ng-deep .event-dot { width: 0.45em; height: 0.45em; }
    .fullscreen-wrapper ::ng-deep .event-text { font-size: 0.75em; }
    .fullscreen-wrapper ::ng-deep .event-badge { font-size: 0.5em; padding: 0.15em 0.4em; }
    .fullscreen-wrapper ::ng-deep .bottom-link { font-size: 0.7em; margin-top: 0.5em; padding-top: 0.4em; }
    .fullscreen-wrapper ::ng-deep .focus-list { gap: 0.5em; }
    .fullscreen-wrapper ::ng-deep .focus-left strong { font-size: 0.75em; }
    .fullscreen-wrapper ::ng-deep .focus-left span { font-size: 0.65em; }
    .fullscreen-wrapper ::ng-deep .focus-site { font-size: 0.7em; }
    .fullscreen-wrapper ::ng-deep .focus-link { font-size: 0.7em; }
  `]
})
export class PilotageFullscreenComponent {
  baseFontSize = 14;

  constructor() {
    this.calculateFontSize();
  }

  @HostListener('window:resize')
  onResize() {
    this.calculateFontSize();
  }

  private calculateFontSize() {
    const vh = window.innerHeight;
    const vw = window.innerWidth;
    // Plus le diviseur est petit, plus le texte est gros
    this.baseFontSize = Math.min(vh / 45, vw / 75, 24);
    this.baseFontSize = Math.max(this.baseFontSize, 12);
  }
}
